<template>
    <section>
        <div class='container'>
            <div class='text-title'>
                Subscription Renewal Using Prepaid Code
                <p class='text-caption text-italic' runat='server'>Applies to: {{ appliesToText }}</p>
            </div>

            <p>
                Once you have the software installed, follow these steps to purchase and activate
                your license.
            </p>

            <p>
                If you need the setup file to install the software, go to the corresponding downloads
                page:
            </p>

            <ul style='list-style-type: none;' class='helpTable'>
                <li><router-link to='/Download/LoopCAD'>Download LoopCAD</router-link></li>
                <li><router-link to='/Download/HeatCAD'>Download HeatCAD</router-link></li>
            </ul>

            <p class='text-red '>
                If your Subscription has been lapsed for more than 3 months, the renewal process
                will first reinstate it and then
                add a new 12-month term (starting from the renewal date). The cost for reinstatement
                is 75% of the Subscription
                fees for the first 12-months lapsed, and 50% of the fees for the remainder of the
                lapsed period. (Subject to
                change without prior notice.)
            </p>

            <p>
                If you do not have a Prepaid Code, see the <router-link to='/Support/Help/Renew-CC'> Subscription Renewal Using a Credit Card </router-link> help topic.
            </p>

            <ol class='help-listStyle q-mt-lg'>
                <li>
                    Run the program
                    <span class='text-weight-medium'>on the computer that you want activated</span>.
                </li>
                <li>
                    <p>If the Activation window does not automatically open, click the <span class='text-weight-medium'>Activate</span> link.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/Activate Link.jpg')" />
                </li>
                <li>
                    <p>Click the '<span class='text-weight-medium'>Purchase or Renew License</span>' option. This will take you to the activation website.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/PurchaseNewLicense.jpg')" />
                </li>
                <li>
                    <p>The website will now open. Select the '<span class='text-weight-medium'> Activate a pre-purchase license </span>' option, then click <span class='text-weight-medium'>Continue</span> to proceed.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/Prepurchased option_Website.jpg')" />
                </li>
                <li>
                    <p>Input your <span class='text-weight-medium'>Prepaid Code</span> (or License Key) in the field provided, including all dashes, and then click the <span class='bold italic'>Validate code...</span> link.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/PrepaidCode_Website.jpg')" />
                </li>
                <li>
                    Click <span class='text-weight-medium'>Continue</span> and login to you account when prompted. If you do not recall your password, use the '<span class='text-weight-medium'>Forgot Password?</span>' link.
                </li>
                <li>
                    When you get to the Shopping Cart page, click <span class='text-weight-medium'>Checkout</span> to proceed to the payment page.
                </li>
                <li>
                    <p>When completed, the Activation Code will be displayed on screen and will also be sent to you by email.</p>
                    <p><img class="img-fit" :src="require('@/assets/img/help/ActivationCodeField.jpg')" /></p>
                    <p>For help on entering your new activation code, see the <router-link to='/Support/Help/Enter-Activation'> Entering an Activation Code </router-link> help topic.</p>
                </li>
            </ol>
        </div>
    </section>
</template>
<script>
    import { productLines } from '@/plugins/productLines'
    export default {
        name: 'renew-prepaid',
        data() {
            return {
                appliesToText: productLines.LoopCAD.name + ' ' + productLines.LoopCAD.year + ', '
                    + productLines.HeatCAD.name + ' ' + productLines.HeatCAD.year
            }
        }
    }
</script>
